import React, {useEffect, useState} from "react";
import {Card} from "react-bootstrap";
import {Photo} from "../../types/Types";
import {collection, getDocs, limit, orderBy, query, where} from "@firebase/firestore";
import {db} from "../../../firebase/FirebaseProvider";
import {Link} from "react-router-dom";
import {logDataLoaded} from "../../util/Util";

interface Props {
    socialDisabled: boolean;
}

function RecentPhotosWidget(props: Props) {
    const [photos, setPhotos] = useState<Array<Photo> | undefined>(undefined);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        (async () => {
            await loadPhotos();
        })();
    }, []);

    const loadPhotos = async() => {
        // Load photos
        let photos: Array<Photo> = [];
        const photosOnceCollection = query(collection(db, 'photos'),
            where('hidden', '==', false),
            orderBy('createdAt', 'desc'),
            limit(9));
        const photosOnceCollectionSnapshot = await getDocs(photosOnceCollection);
        photosOnceCollectionSnapshot.forEach((doc) => {
            let tempPhoto = doc.data() as Photo;
            tempPhoto.id = doc.id;
            photos.push(tempPhoto);
        });
        logDataLoaded('widget recent photos', photos.length);
        setPhotos(photos);
        setLoading(false);
    };

    if (props.socialDisabled) {
        return null;
    }

    return (
        <Card className={"mt-3 mb-3"}>
            <Card.Header>
                <div className="d-flex justify-content-between align-items-center">
                    <div><b>Recent Photos</b></div>
                    <small><Link to="/hub/photos" className="text-decoration-none">View more</Link></small>
                </div>
            </Card.Header>
            <Card.Body style={{padding: "1em"}}>
                {loading ? (
                    <div className={'loading'}>Loading...</div>
                ) : (
                    <div style={{textAlign: "center"}}>
                        {photos && photos.map((photo, index) => (
                            <Link key={index} to={`/location/${photo.locationId}/photos`}>
                                <div style={{marginLeft: "0.2em", marginRight: "0.2em", marginBottom: "0.2em", marginTop: "0.2em"}} className={"d-inline-block"}>
                                    <img className={"mini-photo"} src={photo.smallSizeUrl} alt=""/>
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </Card.Body>
        </Card>
    );
}

export default RecentPhotosWidget;
